
import type { PropType } from 'vue'
import { PaymentRequest, WaybillByPaymentRequest } from '@/modern/modules/m-accounting-module/services/types/payment-requests.types'

import { defineComponent } from 'vue'

// > helpers/formatDate <
import formatDate from '@/modern/helpers/formatDate'

export default defineComponent({
    props: {
        paymentRequest: {
            type: Object as PropType<PaymentRequest>,
            required: true
        },
        waybill: {
            type: Object as PropType<WaybillByPaymentRequest>,
            required: true
        }
    },
    setup() {
        return {
            formatDate
        }
    }
})
